module.exports = __webpack_public_path__ + "static/littleWomen4s-deca40bb73873a8baa176da345e24694.jpg";